<template>
  <div class="bg-[#e9e9ea] px-4 py-6">
    <p class="mb-16 flex justify-start">
      <a href="https://www.nhk-book.co.jp/" target="_blank" rel="noopener"
        ><Img src="/images/ranking/footer/footer_logo_01.svg" alt="NHK出版"
      /></a>
    </p>
    <p class="text-center text-xs">Copyright NHK Publishing, Inc.</p>
  </div>
</template>

<script setup lang="ts"></script>
